/* assets/bhr-him-timeline.js - sections/bhr-him-timeline.liquid
   ---------------------------------------------------------------------------
   No libraries, by design. Two things happen here and nothing else:
     1. IntersectionObserver adds .is-in once per step, then unobserves it.
     2. The amber line fill is redrawn on scroll, rAF-throttled, from cached
        geometry - the scroll path reads no layout at all.
   Both run at every width - mobile included.

   Written for MORE THAN ONE instance on the page. The mobile and desktop
   trees are separate sections, so every query is per-instance and the film
   id / play button are resolved from the closest .bhr-tlx rather than from
   document - with document.querySelector the desktop tree would read the
   mobile tree's film. The hidden tree is skipped entirely: it has a zero
   bounding box, and dividing by its height produced Infinity.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* The section renders this tag once per instance, so on a page carrying both
     trees the file is requested twice. Without this guard the observers and
     scroll listeners would be bound twice over. */
  if (window.__bhrTlxInit) return;
  window.__bhrTlxInit = true;

  function boot() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var steps = document.querySelectorAll('.bhr-tlx-step');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      Array.prototype.forEach.call(steps, function (s) { io.observe(s); });
    } else {
      Array.prototype.forEach.call(steps, function (s) { s.classList.add('is-in'); });
    }

    var rails = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-tlx-wrap]'), function (wrap) {
      var fill = wrap.querySelector('[data-tlx-fill]');
      if (fill) rails.push({ wrap: wrap, fill: fill, top: 0, height: 0, last: -1 });
    });

    /* Layout viewport, NOT window.innerHeight. On a phone the address bar
       collapses and re-expands as you scroll, and innerHeight moves with it -
       60-100px, mid-gesture. The fill's target line is a fraction of that, so
       every toolbar transition yanked the line by ~50-80px. clientHeight is
       the layout viewport and ignores the toolbar entirely. */
    var vh = document.documentElement.clientHeight;
    var ticking = false;
    var measuring = false;

    /* Geometry is measured on resize/load/content-change and cached - never
       inside the scroll handler. getBoundingClientRect() forces a synchronous
       layout, so reading it every frame made the browser lay out the whole
       (very tall) timeline mid-scroll, which is what shed frames and made the
       fill stutter. Scroll frames are now pure arithmetic plus one style
       write. offsetParent is null inside a display:none ancestor, which is
       exactly what the device gate does to the tree not in play - a zero
       height parks that rail and draw() skips it. */
    function measure() {
      vh = document.documentElement.clientHeight;
      rails.forEach(function (r) {
        if (r.wrap.offsetParent === null) { r.height = 0; return; }
        var box = r.wrap.getBoundingClientRect();
        r.top = box.top + window.pageYOffset;
        r.height = box.height;
      });
    }

    function draw() {
      if (reduced) return;
      var line = window.pageYOffset + vh * 0.78;
      rails.forEach(function (r) {
        if (r.height <= 0) return;
        var p = (line - r.top) / r.height;
        p = p < 0 ? 0 : (p > 1 ? 1 : p);
        /* Rounded, then compared: without this the same visual position keeps
           producing a new 15-digit string and every frame pays for a style
           recalculation that changes nothing on screen. */
        p = Math.round(p * 1e4) / 1e4;
        if (p === r.last) return;
        r.last = p;
        r.fill.style.transform = 'scaleY(' + p + ')';
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; draw(); });
    }

    function remeasure() {
      if (measuring) return;
      measuring = true;
      requestAnimationFrame(function () { measuring = false; measure(); draw(); });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasure, { passive: true });
    window.addEventListener('orientationchange', remeasure, { passive: true });
    /* Images and webfonts land after DOMContentLoaded and change the
       timeline's height; a cache taken before that would be wrong for the
       whole session. */
    window.addEventListener('load', remeasure);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(remeasure);
      rails.forEach(function (r) { ro.observe(r.wrap); });
    }

    measure();
    draw();

    /* Click-to-load facade. The iframe is created on click and never before -
       no YouTube request of any kind on initial load. */
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest ? ev.target.closest('[data-tlx-play]') : null;
      if (!btn) return;
      var root = btn.closest('.bhr-tlx');
      var box = btn.closest('[data-tlx-filmbox]');
      if (!root || !box) return;
      var id = root.getAttribute('data-bhr-film-id');
      if (!id) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      f.title = root.getAttribute('data-bhr-film-title') || 'The harvest film';
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      f.setAttribute('allowfullscreen', '');
      box.innerHTML = '';
      box.appendChild(f);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
